import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('etd_wise')
export class EtdWise {
    @PrimaryGeneratedColumn('increment', {
        name: 'etd_wise_id',
    })
    etdWiseId: number;

    @Column('int', {
        nullable: false,
        name: 'sale_order_id',
    })
    saleOrderId: number;

    @Column("date", {
        nullable: false,
        name: "actual_eda_date"
    })
    actualEdaDate: Date;

    @Column('int', {
        nullable: false,
        name: 'unit_id',
        default: 0
    })
    unitId: number;

    @Column("date", {
        nullable: false,
        name: "revised_eda_date"
    })
    revisedEdaDate: Date;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}